import React, { useEffect, useState } from 'react';  
import { Grid, Typography, Paper, Divider } from '@mui/material';
import MainCard from '../../ui-component/cards/MainCard';
import { gridSpacing } from '../../store/constant';
import { Link, Route, Switch, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import { IconMail, IconPhone } from '@tabler/icons';
import axiosInstance from '../../axiosInstance';
import { useSelector } from 'react-redux';
import configData from '../../config';
import ChangePasswordPage from './ChangePasswordPage';

function UserProfile() {
    const [userData, setUserData] = useState({ name: null, role: null });
    const [reportData, setReportData] = useState([]);
    const [allocatedLicenses, setAllocatedLicenses] = useState([]);
    const [remainingLicenses, setRemainingLicenses] = useState(0);

    const org_id = useSelector((state) => state?.account?.org?.id || state?.account?.org_data?.data?.id);
    const account = useSelector((state) => state.account);
    const org_member = useSelector((state) => state?.account?.org_member);
    const org_member_data = useSelector((state) => state?.account?.org_data?.org_member_data);
    const userRole = useSelector((state) => state.account.role);
    const licensesAssigned = account?.org_member?.licensesAssigned || 'Not Available';

    const [activeSection, setActiveSection] = useState('user-report-allocation');
    const { path, url } = useRouteMatch();
    const location = useLocation();
    const history = useHistory();

    // Redirect on initial load
    useEffect(() => {
        if (location.pathname === url) {
            history.push(`${url}/reports-allocation`);
        }
    }, [location.pathname, url, history]);


    // Fetch allocated reports
    useEffect(() => {
        const abortController = new AbortController();
        const fetchReportData = async () => {
            try {
                let res;
                if (account.role === 'Super Admin') {
                    res = await axiosInstance.get(`${configData.API_SERVER}/user/allocated-reports?org_id=${org_id}`, { signal: abortController.signal });
                } else if (account.role === 'Owner') {
                    res = await axiosInstance.get(`${configData.API_SERVER}/user/get_all_reports`, { signal: abortController.signal });
                } else {
                    const user = await axiosInstance.get(`${configData.API_SERVER}/user/get_user_with_email?email=${account.org_member.email}`, { signal: abortController.signal });
                    res = await axiosInstance.get(`${configData.API_SERVER}/user/allocated-reports?user_id=${user?.data?.id}`, { signal: abortController.signal });
                }
                setReportData(res?.data || []);
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error("Error fetching report data:", error);
                }
            }
        };

        fetchReportData();
        return () => {
            abortController.abort();
        };
    }, [account, org_id]);

    // Fetch license allocation details
    
    const renderAllocatedReports = () => {
        if (reportData.length === 0) {
            return <Typography>No reports allocated.</Typography>;
        }
        return (
            <ul>
                {reportData.map((report, index) => (
                    <li key={index}>
                        <Typography>{report.title}</Typography>
                        {report.children && report.children.length > 0 && (
                            <ul>
                                {report.children.map((subReport, subIndex) => (
                                    <li key={subIndex}>
                                        <Typography variant="body2">{subReport.title}</Typography>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <MainCard title="User Profile">
            <Paper elevation={2} sx={{ padding: 3 }}>
                <Grid container spacing={gridSpacing} alignItems="center">
                    <Grid item lg={3} md={4} sm={12} xs={12}>
                        <Typography variant="h4" sx={{ fontSize: '25px', fontFamily: 'sans-serif', marginBottom: '0' }}>
                            {userData.name || (org_member ? org_member.memberName : org_member_data ? org_member_data.memberName : null)}
                        </Typography>
                        <Typography variant="subtitle2" color="primary" sx={{ fontFamily: 'sans-serif', fontWeight: '600', color: '#0d6efd', fontStyle: 'italic', marginTop: '0', fontSize: '12px' }}>
                            {userData.role || 'CEO'}
                        </Typography>
                    </Grid>
                    <Grid item lg={9} md={8} sm={12} xs={12}>
                        <Typography variant="body1" gutterBottom>
                            <IconMail stroke={1.5} size="1.3rem" /> &nbsp;{account?.org?.email || 'Email not available'}
                        </Typography>
                        <Typography variant="body1">
                            <IconPhone stroke={1.5} size="1.3rem" /> &nbsp;{account?.org?.phone || 'Phone not available'}
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>

            <Divider sx={{ my: 3 }} />

            <nav style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                <Link
                    to={`${url}/reports-allocation`}
                    onClick={() => setActiveSection('user-report-allocation')}
                    style={{
                        textDecoration: activeSection === 'user-report-allocation' ? 'underline' : 'none',
                        fontWeight: activeSection === 'user-report-allocation' ? 'bold' : 'normal',
                        color: '#0d6efd',
                    }}
                >
                    Report Allocated
                </Link>
                <Link
                    to={`${url}/change-password`}
                    onClick={() => setActiveSection('change-password')}
                    style={{
                        textDecoration: activeSection === 'change-password' ? 'underline' : 'none',
                        fontWeight: activeSection === 'change-password' ? 'bold' : 'normal',
                        color: '#0d6efd',
                    }}
                >
                    Change Password
                </Link>
            </nav>

            <Switch>
                <Route
                    path={`${path}/reports-allocation`}
                    component={() => (
                        <div>
                            <Typography variant="h6">Reports Allocated:</Typography>
                            {renderAllocatedReports()}
                        </div>
                    )}
                />
                <Route path={`${path}/change-password`} component={ChangePasswordPage} />
            </Switch>

            <Typography variant="body2" color="textSecondary" align="center" sx={{ mt: 4 }}>
                &copy; {new Date().getFullYear()} IMAGE-I
            </Typography>
        </MainCard>
    );
}

export default UserProfile;
